







































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import BookingRoleWorkerShiftDto from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftDto';
import SelectableEntity from '@/models/Shared/SelectableEntity';
import ConfirmAppliedBookingRoleWorkerRequest from '@/models/BookingRoleWorkers/ConfirmAppliedBookingRoleWorkerRequest';
import BookingOfferShiftViewModel from '@/models/BookingRoleWorkerShifts/BookingOfferShiftViewModel';
import BookingOfferShiftReply from '@/models/BookingRoleWorkerShifts/BookingOfferShiftReply';
import ListUtils from '@/lib/listUtils';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ShiftDeclinedReason from '@/models/Shared/ShiftDeclinedReason';

@Component({
    name: 'BookingManageWorkersApplyDecline'
})
export default class extends GiganautVueDialog {
 
  @Prop()
  selectedBookingRole: BookingRoleDto;
  public shifts: BookingOfferShiftViewModel[] = [];
  public selectedShiftIds: string[] = [];
  public dialog = false;
  public test = true;
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    this.selectedShiftIds = [];
      this.shifts =  BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.bookingRoleWorkerShifts.map(function(bookingRoleWorkerShift) {
        const shiftVM = new BookingOfferShiftViewModel();
        //console.log(bookingRoleWorkerShift);
        shiftVM.bookingRoleWorkerShiftId = bookingRoleWorkerShift.id;
        shiftVM.shift = bookingRoleWorkerShift.shift;
        return shiftVM;
      });
  }

  async updateSelectedShifts(val: boolean, shift: BookingRoleWorkerShiftDto) {
    	if (val) {
			  this.selectedShiftIds.push(shift.id);
		} else {
			  const index = this.selectedShiftIds.indexOf(shift.id);
        this.selectedShiftIds.splice(index, 1); 
		}
	}

  get declinedReasons() {
    return ListUtils.shiftDeclinedReasons();
  }

  get loading() {
    return BookingDetailsModule.loadingDialog;
  }

  get selectedBookingRoleWorker() {
      return BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker;
  }

  async update() { 
     if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new ConfirmAppliedBookingRoleWorkerRequest();
    request.updatedAt = BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.updatedAt;
    request.isApplication = true;
    request.replies = this.shifts.map(function(vm: BookingOfferShiftViewModel) {
      const reply: BookingOfferShiftReply = new BookingOfferShiftReply();
      reply.bookingRoleWorkerShiftId = vm.bookingRoleWorkerShiftId;
      reply.applied = vm.applied;
      if (reply.applied) {
        reply.declinedReason = ShiftDeclinedReason.BOOKING_DECLINED_REASON_UNDEFINED;
      } else {
        reply.declinedReason = vm.declinedReason;
      }
      return reply;
    });
    await BookingDetailsModule.confirmAppliedBookingRoleWorker(request);
    await BookingDetailsModule.updateOfferedSelectedBookingRole(this.selectedBookingRole);

    this.dialog = false;
  }
}
